import React from "react";
import { Text, Stack, HStack, Flex } from "@chakra-ui/react";
import { textSecondary, textPrimary } from "../../../../utils/colors";
import dayjs from "dayjs";
import StatusButtonNewLiteTp from "../../../../components/buttons/StatusButtonNewLiteTp";

export const columnsMobile = (translate, handleSortChange) => [
  {
    Header: () => (
      <Flex onClick={() => handleSortChange("treatmentPlanID")} h="100%">
        <Flex align="center" cursor="pointer">
          <Text mr={2}>{translate("patient.columnID")}</Text>
        </Flex>
      </Flex>
    ),
    accessor: "treatmentPlanID",
    disableSortBy: true,
    width: 100,
    Cell: ({ row }) => {
      const { treatmentPlanID } = row.original;

      return (
        <Text
          textAlign="left"
          overflow="hidden"
          whiteSpace="nowrap"
          fontSize="xs"
          color={textSecondary}
          fontWeight="500"
        >
          {treatmentPlanID}
        </Text>
      );
    },
  },
  {
    Header: () => (
      <Flex onClick={() => handleSortChange("createdAt")} h="100%">
        <Flex align="center" cursor="pointer">
          <Text mr={2}>{translate("treatmentPlan.columnCreated")}</Text>
        </Flex>
      </Flex>
    ),
    accessor: "createdAt",
    width: 100,
    disableSortBy: true,
    Cell: ({ row }) => {
      const { createdAt } = row.original;

      // Get the formatted date
      const createdAtDate = dayjs(createdAt).format("MMMM DD");

      // Get the current year and the year of the createdAt date
      const createdYear = dayjs(createdAt).year();
      const currentYear = dayjs().year();

      return (
        <Stack gap={0}>
          <Text
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize="sm"
            fontWeight="500"
            color={textPrimary}
            textTransform="capitalize"
            textAlign="left"
          >
            {createdAtDate}
          </Text>
          {createdYear !== currentYear && ( // Only show year if it's not the current year
            <Text
              fontSize="xs"
              color={textSecondary}
              fontWeight="500"
              textAlign="left"
              mt="3px"
            >
              {createdYear}
            </Text>
          )}
        </Stack>
      );
    },
  },

  {
    Header: () => (
      <Flex onClick={() => handleSortChange("status")} w="100%" h="100%">
        <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
          <Text mr={2}>{translate("patient.columnStatus")}</Text>
        </Flex>
      </Flex>
    ),
    accessor: "status",
    disableSortBy: true,
    preventRowClick: false,
    Cell: ({ row }) => {
      const { status } = row.original;

      const handleUpdateStatus = (newStatus) => {
        // dispatch(updateSpeakerStatus(_id, newStatus));
      };

      // console.log("patient", patient);

      return (
        <HStack gap={0} justify="flex-end">
          <StatusButtonNewLiteTp
            currentStatus={status}
            onUpdateStatus={handleUpdateStatus}
            options="treatment"
            isRounded
            p="0 0rem"
            w="120px"
          />
        </HStack>
      );
    },
  },
];
